@if (dialog.active()) {
  <div class="pathways-modal-backdrop account-settings-dialog-backdrop" (click)="onBackdropClick()">
    <div
      class="account-settings-dialog"
      role="dialog"
      aria-modal="true"
      aria-label="Account settings"
      (click)="$event.stopPropagation()"
    >
      <div class="settings-shell">
        <nav class="settings-nav" aria-label="Settings sections">
          <div class="settings-title">
            <i class="fa-solid fa-gear" aria-hidden="true"></i>
            Account settings
          </div>
          @for (tab of tabs; track tab.id) {
            <button
              type="button"
              class="settings-nav-item"
              [class.active]="activeTab() === tab.id"
              (click)="activeTab.set(tab.id)"
            >
              <i [class]="tab.icon" aria-hidden="true"></i>
              {{ tab.label }}
            </button>
          }
        </nav>

        <div class="settings-content">
          <div class="settings-panel-scroll" #scrollPanel>
            <app-account-settings
              [dialogMode]="true"
              [activeTab]="activeTab()"
              (requestClose)="requestClose()"
            />
          </div>
          <footer class="settings-footer">
            <button type="button" class="pathways-btn-secondary" (click)="requestClose()">
              Cancel
            </button>
            <button type="button" class="pathways-btn-primary" (click)="onSave()">
              Save changes
            </button>
          </footer>
        </div>
      </div>
    </div>
  </div>
}
